import React, { useEffect, useState, Suspense } from 'react';
import './index.css';
import { Auth } from "aws-amplify";
import DoctorAdmin from './components/admins/app'
import { AuthContext } from './context/authContext';
import { withApollo } from '@apollo/react-hoc';
import { getFormSubscriberByEmail } from './graphql/queries'
import MainLayout from './components/common/layout';

var jwtDecode = require('jwt-decode');

const getFormSubscriberByEmailQuery = async (props, variables) => {
  return await new Promise((res, rej) => {
    props.client.query({
      query: getFormSubscriberByEmail,
      variables:variables,
      fetchPolicy:'no-cache'
    }).then((data) => {
      res(data)
    }).catch((err) => {
      console.log(err)
      rej(err)
    })
  })
}

const getAuthData = async()=>{
    let res = await Auth.currentAuthenticatedUser();
    var sessionIdInfo = jwtDecode(res.signInUserSession.idToken.jwtToken);
    // console.log(sessionIdInfo)
      return {
        userId: sessionIdInfo.email,
        phone_number:sessionIdInfo.phone_number,
        groups:sessionIdInfo['cognito:groups'] ? sessionIdInfo['cognito:groups'] : [],
        sessionIdInfo:sessionIdInfo,
        user:res
      };
}


const App = (props)=>{
    const [user, setuser] = useState(null)
    const [data, setdata] = useState(null)
    const [arr, setarr] = useState([])
    const [resData, setresData] = useState(null)
    const [loading, setloading] = useState(null)


    useEffect(async() => {
        let res = await getAuthData();
        setresData(res);
        let grs = [];
        grs = res.groups;
        setarr(grs)
        let adminFlag = true;
        if(grs.indexOf('Admin') != -1){
          adminFlag = false;
          setloading(false)
        }else
        if(grs.indexOf('FormSubscriber') != -1){
          setloading(true)
          let variables={
            typeValue: 'subscriber',
            email:res.user.attributes.email
          }
          getFormSubscriberByEmailQuery(props, variables)
          .then(({data})=>{
            let expDate = data.getFormSubscriberByEmail.expiryDate;
            let now = new Date().getTime();
            let obj = data.getFormSubscriberByEmail;
            obj.expired = false;

            if(expDate*1000 < now){
              obj.expired = true;
            }

            setdata(obj)
            setloading(false)
          }).catch((err)=>{
            console.log(err)
            setloading(false)

          })
        }else{
          setloading(false)
        }

        setuser(res)
      },[]); 


  return (
    <Suspense fallback={<MainLayout>Loading...</MainLayout>}>
      {/* <AuthWrapper> */}
      <AuthContext.Provider value={{user:user, permissions:arr, data:data,resData:resData, isDoctor: data != null ? true : false, loading:loading}}>
          <DoctorAdmin/>
      </AuthContext.Provider>

      {/* </AuthWrapper> */}
    </Suspense>
  );
}


export default withApollo(App);
// export default withTranslation()(App);
